import { connect } from 'react-redux';
import { compose } from 'redux';

import { simoSubPage } from 'decorators/subPage';
import notePage from 'decorators/notePage';
import {
  findSimoSub,
  updateSimoSub,
  updateSimoSubCycleType,
} from 'actions/simoSubs';
import { getIncludedInGroups, getIsAdmin, getLoggedInUser } from 'reducers';

import ViewSub from './ViewSub';
import SimoSub from 'components/simo/SimoSub';
import { fetchSimoUsageBalance } from 'api';
import { withSimoCurrentCycle } from 'decorators/withCurrentCycle';
import withSimoDiagnosticData from 'decorators/withSimoDiagnosticData';
import SimoSubActions from 'components/SubActions/simo';
import { withSimoPlans } from 'decorators/withPlans';

const mapStateToProps = (state, { subId }) => ({
  isAdmin: getIsAdmin(state),
  loggedInUser: getLoggedInUser(state),
  isAdminOrManagerOrBusiness: getIncludedInGroups(state, [
    'ADMIN',
    'MANAGER',
    'BUSINESS',
  ]),
  pageUrl: (subId, pageNum) =>
    `/simo/subscription/${subId}/view?page=${pageNum}`,
  fetchSimoUsageBalance,
  Sub: SimoSub,
  SubActions: SimoSubActions,
});

const mapDispatchToProps = {
  findSub: findSimoSub,
  updateSimoSubCycleType,
  updateSub: updateSimoSub,
};

export default compose(
  simoSubPage,
  withSimoDiagnosticData,
  withSimoCurrentCycle,
  withSimoPlans,
  notePage,
)(connect(mapStateToProps, mapDispatchToProps)(ViewSub));
